<template>
  <div class="row pt-3">
    <div class="col">
      <div
        v-if="profile.description"
        class="self-description mb-4"
        v-html="profile.description"
      />
      <profile-section-header title="Profile Information" />
      <div class="d-flex flex-wrap align-items-center">
        <!-- <h2 class="font-22-900 dark-text mb-0 mr-2">Latest Education:</h2> -->
        <ul class="profile-status-list">
          <GfbOptionDisplay :status="isAdultStatus" :text="isAdultText" />
          <GfbOptionDisplay
            :status="authorizedInUSStatus"
            :text="authorizedInUSText"
          />
          <GfbOptionDisplay
            :status="requireSponsorshipStatus"
            :text="requireSponsorshipText"
          />
          <GfbOptionDisplay
            :status="booleanToOptionStatus(profile.jobSeeker.isVeteran)"
            :text="
              profile.jobSeeker.isVeteran
                ? `Veteran${
                    profile.jobSeeker.veteranStatusOptions
                      ? ` (${profile.jobSeeker.veteranStatusOptions})`
                      : ''
                  }`
                : 'Veteran'
            "
          />
        </ul>
        <ProfileSubSectionHeader
          title="Highest Level of Education"
          icon="education-icon"
        />
        <capsule-list
          :items="
            profile.jobSeeker.latestEducation
              ? [profile.jobSeeker.latestEducation]
              : []
          "
          :highlighted="true"
        />
      </div>
      <div class="d-flex flex-wrap align-items-center mb-2">
        <ProfileSubSectionHeader
          title="Trade Category Interests"
          icon="trade-experience-icon"
        />
        <capsule-list
          v-if="profile.jobSeeker.interestedCategories?.length"
          :items="profile.jobSeeker.interestedCategories"
          :highlighted="true"
        />
        <p v-else class="no-experience mb-0">None provided</p>
      </div>
      <div class="mt-3 pt-3" v-if="shouldDisplayTraining">
        <editable-paragraph
          title="Training"
          :content="profile.jobSeeker.formalTrainingDescription || ''"
          dataKey="overview"
          @handle-click="$emit('handle-click')"
          :isEditing="isEditing"
        />
        <capsule-list
          class="mt-4"
          :items="profile.jobSeeker.formalTrainingCategories || []"
          :highlighted="true"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ProfileSectionHeader from "../ProfileSectionHeader.vue"
import ProfileSubSectionHeader from "../ProfileSubSectionHeader.vue"
import GfbOptionDisplay from "@/components/GfbOptionDisplay"
import { booleanToOptionStatus } from "@/utils/converters"
import { isProfileUnlocked } from "@/utils/profileAccess"

export default {
  name: "candidate-profile-overview",
  components: {
    ProfileSectionHeader,
    ProfileSubSectionHeader,
    GfbOptionDisplay,
  },
  methods: {
    booleanToOptionStatus,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    isEditing: {
      type: Boolean,
      default: false,
    },
    applicant: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isAdultStatus() {
      const { isAdult } = this.profile.jobSeeker
      if (isAdult === true) return "success"
      if (isAdult === false) return "warning"
      return "missing"
    },
    isAdultText() {
      const { isAdult } = this.profile.jobSeeker
      if (isAdult === true) return "Applicant is 18 years of age or older"
      if (isAdult === false) return "Applicant is under 18 years of age"
      return "Age eligibility not yet provided"
    },
    authorizedInUSStatus() {
      const { authorizedInUS } = this.profile.jobSeeker
      if (authorizedInUS === true) return "success"
      if (authorizedInUS === false) return "warning"
      return "missing"
    },
    authorizedInUSText() {
      const { authorizedInUS } = this.profile.jobSeeker
      if (authorizedInUS === true) {
        return "Applicant is legally authorized to work in the United States"
      }
      if (authorizedInUS === false) {
        return "Applicant is not legally authorized to work in the United States"
      }
      return "Work authorization status not yet provided"
    },
    requireSponsorshipStatus() {
      const { requireSponsorship } = this.profile.jobSeeker
      if (requireSponsorship === true) return "warning"
      if (requireSponsorship === false) return "success"
      return "missing"
    },
    requireSponsorshipText() {
      const { requireSponsorship } = this.profile.jobSeeker
      if (requireSponsorship === true) {
        return "Applicant currently, or in the future, will require immigration sponsorship for work authorization (e.g. H-1B)"
      }
      if (requireSponsorship === false) {
        return "Applicant does not require immigration sponsorship for work authorization (e.g. H-1B)"
      }
      return "Sponsorship requirement not yet provided"
    },
    shouldDisplayTraining() {
      const { hasFormalTraining, formalTrainingCategories } =
        this.profile.jobSeeker ?? {}
      return hasFormalTraining && formalTrainingCategories?.length > 0
    },
    hasFullProfileViewAccess() {
      return isProfileUnlocked(
        this.$store.state.userProfile?.provider.unlockedApplicants,
        this.profile._id
      )
    },
  },
}
</script>
<style lang="scss" scoped>
.self-description {
  font-size: 14px;
  color: var(--Gray-700, #525e77);
  line-height: 1.6;
}

.no-experience {
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  text-align: left;
}

.profile-status-list {
  width: 100%;
  list-style: none;
  padding: 0;
  margin-top: 20px;
  list-style: none;

  li {
    margin-bottom: 18px;
    font-weight: 600;

    svg {
      margin-right: 8px;
    }
  }
}
</style>
